import React, { Component } from 'react'
import { Grid, Header, Modal, Segment, Button, Confirm, Dimmer, Loader } from 'semantic-ui-react';
import './ServiceRequestSinglePlaceBidModal.less';
import DGTextbox from 'components/FormControls/Textbox/DGTextbox';
import DGDateTimePicker from 'components/FormControls/DateTimePicker/DGDateTimePicker';
import Formsy, { addValidationRule } from 'formsy-react';
import { placeBid } from 'services/Manager';
import { GeneralError } from 'components/GeneralError/GeneralError';
import { IN_TRIAL } from 'constants/SellerSubscriptionStatus';
import marker_red from '../../assets/images/newui/newrequestpage/marker_red.svg';
import marker_trial_purple from '../../assets/images/newui/newrequestpage/marker_trial_purple.svg';
import marker_green from '../../assets/images/newui/newrequestpage/marker_green.svg';

const initialState = {
    bidValue: 0,
    sellerAvailability: null,
    loading: false,
    bidSubmissionMessage: '',
    showBidPlacementConfirmation: false,
    loadingText: '',
    windowWidth: window.innerWidth,
    isUpdated: false
};

addValidationRule('isMoreThanZero', function (values, value, otherField) {
    // The this context points to an object containing the values
    // {childAge: "", parentAge: "5"}
    // otherField argument is from the validations rule ("childAge")
    return Number(value > 0);
});
class ServiceRequestSinglePlaceBidModal extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;
        this.bidPriceTextBoxRef = null;
    }

    async componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth });

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    modalCloseHandler = () => {
        if (!this.state.submittingBid) {
            this.props.onClose(this.state.isUpdated);
            this.resetState();
        }
    }

    onBidAmountChange = (e, { value }) => {
        this.setState({ bidValue: Number(value), bidSubmissionMessage: '' });
    }

    onBidAvailabilityChange = (date) => {
        this.setState({ sellerAvailability: date, bidSubmissionMessage: '' });
    }

    onValidBidSubmit = async () => {
        this.setState({ showBidPlacementConfirmation: true, bidSubmissionMessage: '' });
    }

    onBidSubmissionClick = async () => {
        this.setState({ loading: true, loadingText: 'Submitting bid', submittingBid: true, bidSubmissionMessage: '', showBidPlacementConfirmation: false });
        const placeBidResponse = await placeBid(this.props.selectedServiceRequest.sbr.singleBuyerRequestID, { bidPrice: this.state.bidValue, sellerID: this.props.seller.seller.sellerID, sellerAvailability: this.state.sellerAvailability });
        if (placeBidResponse.resStatus === 200) {
            this.setState({ bidValue: 0, submittingBid: false, isUpdated: true }, () => {
                this.props.onClose(true); // refresh required
                this.resetState();
            });
        }
        else {
            this.setState({ bidSubmissionMessage: placeBidResponse.message, submittingBid: false, showBidPlacementConfirmation: false })
        }
    }

    onBidSubmissionCloseOrCancel = () => {
        this.setState({ showBidPlacementConfirmation: false });
    }

    resetState = () => {
        this.setState({ ...initialState });
    }

    render() {
        return (<Modal
            closeIcon
            open={this.props.open}
            className='modal single-bid-place-modal'
            onClose={this.modalCloseHandler.bind(this)}
        >
            <Header className='modal-header' content={`Place Bid`} />
            <Dimmer.Dimmable as={Modal.Content}>
                <Dimmer active={this.state.submittingBid}>
                    <Loader active={this.state.submittingBid} content="Submitting bid" inverted />
                </Dimmer>
                <Confirm className="confirm"
                    size="large"
                    open={this.state.showBidPlacementConfirmation}
                    closeOnDimmerClick
                    closeOnEscape
                    content="Do you want to continue with the bid placement?"
                    onConfirm={this.onBidSubmissionClick}
                    onCancel={this.onBidSubmissionCloseOrCancel}
                    onClose={this.onBidSubmissionCloseOrCancel}
                />
                <Segment>
                    {this.state.bidSubmissionMessage && this.state.bidSubmissionMessage.length > 0 &&
                        <GeneralError message={this.state.bidSubmissionMessage} />
                    }
                    <Formsy onValidSubmit={this.onValidBidSubmit}>
                        <Grid relaxed columns={2} stackable>
                            {!_.isEmpty(this.props.discount) &&
                                <Grid.Row>
                                    <Grid.Column width={16}>
                                        <div className="bid-modal-promo-display">
                                            Promo Applied: {this.props.discount.discountPercent ? `${this.props.discount.discountPercent}%` : this.props.discount.discountAmount ? `$${this.props.discount.discountAmount}` : ''}
                                        </div>
                                    </Grid.Column>
                                </Grid.Row>
                            }
                            <Grid.Row>
                                {
                                    this.props.seller &&
                                    <Grid.Column computer={16} mobile={16} tablet={16} className={"seller-name"}>
                                        <div className={"icon"}>
                                            <img className={`marker ${(this.props.seller.seller.name.subStatus == IN_TRIAL) || this.props.seller.seller.sellerPlan ? "large" : ""}`} src={this.props.seller.seller.subStatus == IN_TRIAL ? marker_trial_purple : (this.props.seller.seller.sellerPlan ? marker_red : marker_green)} />
                                        </div>
                                        <div className={"name"}>
                                            {this.props.seller.seller.name + ", " + this.props.seller.seller.email + ", " + this.props.seller.seller.city + ", " + this.props.seller.seller.abbreviation}
                                        </div>
                                    </Grid.Column>
                                }
                            </Grid.Row>
                            <Grid.Row>
                                {
                                    !_.isEmpty(this.props.seller) && <React.Fragment>
                                        <Grid.Column computer={7} mobile={16} tablet={16}>
                                            <DGTextbox name="seller-bid-price" label="Bid Price" required
                                                validations={{
                                                    isMoreThanZero: true,
                                                    isNumeric: true
                                                }}
                                                validationErrors={{
                                                    isMoreThanZero: 'The value should be a valid amount',
                                                    isDefaultRequiredValue: 'This field must be provided',
                                                    isNumeric: `This field must be a number`

                                                }}
                                                innerRef={(c) => {

                                                    this.bidPriceTextBoxRef = c;
                                                }}
                                                onChange={this.onBidAmountChange}
                                            />
                                        </Grid.Column>
                                        <Grid.Column computer={7} mobile={16} tablet={16}>
                                            <DGDateTimePicker
                                                name="selleravailability"
                                                label="Availability"
                                                placeholder=""
                                                showresetbutton
                                                onChange={this.onBidAvailabilityChange}
                                            />
                                        </Grid.Column>
                                        <Grid.Column computer={2}>
                                            <Button type="submit" className="btn-primary" >Add Bid</Button>
                                        </Grid.Column>
                                    </React.Fragment>
                                }
                            </Grid.Row>
                        </Grid>
                    </Formsy>
                </Segment>
            </Dimmer.Dimmable>
        </Modal>
        );
    }
}

export default ServiceRequestSinglePlaceBidModal
